"use strict";

exports.__esModule = true;
exports.default = exports.Basic = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n\n    svg * {\n      fill: ", "!important;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    letter-spacing: -0.43px;\n    font-weight: 400;\n    color: ", ";\n\n    ", " {\n      font-size: 14px;\n      letter-spacing: -0.5px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #FFFFFF;\n    border: 1px solid ", ";\n    border-radius: 23.5px;\n    padding: 4px 10px;\n    cursor: pointer;\n    width: max-content;\n\n    .icon {\n      margin-left: 4px;\n    }\n\n    ", " {\n      padding: 6px 20px;\n\n      .icon {\n        margin-left: 10px;\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette;
var Basic = {
  container: (0, _styledComponents.css)(_templateObject(), KineduPalette.shadeMedium, _styles.breakPoints.desktop),
  label: (0, _styledComponents.css)(_templateObject2(), KineduPalette.shadeMediumDark, _styles.breakPoints.desktop),
  isActiveContainer: (0, _styledComponents.css)(_templateObject3(), KineduPalette.kinedu),
  isActiveLabel: (0, _styledComponents.css)(_templateObject4(), KineduPalette.kinedu),
  containerHover: (0, _styledComponents.css)(_templateObject5(), KineduPalette.healthLight30, KineduPalette.healthLight30),
  labelHover: (0, _styledComponents.css)(_templateObject6(), KineduPalette.healthLight30)
};
exports.Basic = Basic;
var TagThemes = {
  Basic: Basic
};
var _default = TagThemes;
exports.default = _default;